import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpStatusCode,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { injectLoadingService } from '@seatix/shared-util-loading';
import { catchError, switchMap, tap, throwError } from 'rxjs';
import { AuthStore } from '../store/auth-store.service';
import { getAuthRetry, isExpectedUnauthorized } from './auth-context';
import { AUTH_DIALOG_HANDLER } from './auth-dialog-handler.token';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);
  const authDialogHandler = inject(AUTH_DIALOG_HANDLER, { optional: true });
  const loadingService = injectLoadingService();
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isLogoutRequest = req.url.includes('/logout');
      if (
        error.status === HttpStatusCode.Unauthorized &&
        !isLogoutRequest &&
        !isExpectedUnauthorized(req)
      ) {
        const { shouldRetry, retryingMessage, message } = getAuthRetry(req);

        if (shouldRetry && authDialogHandler) {
          authStore.clearAuth();
          loadingService.hideAll();
          return authDialogHandler
            .showAuthDialog({
              allowClose: false,
              initialMode: 'social',
              message:
                message ??
                'Tu sesión expiró, ingresa nuevamente para continuar.',
            })
            .pipe(
              switchMap((authenticated) => {
                if (authenticated && authStore.isAuthenticated()) {
                  const loadingRef = loadingService.show({
                    message: retryingMessage ?? 'Reintentando...',
                    cancelable: false,
                  });

                  const retryReq = req.clone();
                  return next(retryReq).pipe(
                    tap({
                      next: () => {
                        loadingRef.close();
                      },
                      error: () => {
                        loadingRef.close();
                      },
                    }),
                  );
                } else {
                  authStore.logoutLocal();
                  router.navigate(['/']);
                  return throwError(() => error);
                }
              }),
            );
        }

        authStore.logoutLocal();
      }
      return throwError(() => error);
    }),
  );
};
